export default __webpack_public_path__ + "static/media/location_city.454e986c.svg";